import { render, staticRenderFns } from "./DateFilter.vue?vue&type=template&id=63b89ae9"
import script from "./DateFilter.vue?vue&type=script&lang=ts"
export * from "./DateFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports